export default __webpack_public_path__ + "static/media/i030vp.b4350b5b.webp";